<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">

  <div fxLayout="row"  fxLayoutGap="32px" gdColumns="auto 25%" fxLayoutAlign="space-between center">
    <kendo-grid
      [kendoGridBinding]="gridDataExceptions"
      [kendoGridSelectBy]="selectedCallback"
      [(selectedKeys)]="mySelection"
      [selectable]="{enabled: true, checkboxOnly: true}"
      [filterable]="true"
      [resizable]="true"
      [sortable]="true"
      [scrollable]="true"
      [pageSize]="20"
      [height]="400"
      [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"

      style="height: 35vh">

      <kendo-grid-checkbox-column  showSelectAll="true" [width]="45"></kendo-grid-checkbox-column>
      <kendo-grid-column field="divId" title="Div Id" filterable="true" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="chn" title="Chain" filterable="true" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="itemNum" title="Item #" filterable="true" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="itemDesc" title="Desc" filterable="true" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="currentGL" title="Current GL" filterable="true" [width]="150"></kendo-grid-column>
    </kendo-grid>


    <kendo-grid
      [kendoGridBinding]="gridDateGLCodes"
      [kendoGridSelectBy]="selectedCallbackGLCodes"
      [(selectedKeys)]="mySelectionGLCodes"
      [selectable]="{checkboxOnly: false, mode: 'single'}"
      [scrollable]="true"
      [height]="400"
      style="height: 35vh">
      <kendo-grid-checkbox-column [width]="55"></kendo-grid-checkbox-column>
      <kendo-grid-column field="code" title="GL Codes" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description" [width]="200"></kendo-grid-column>
    </kendo-grid>

  </div>

  <div fxLayout="row" fxLayoutAlign="end stretch" style="margin-top: 10px">
    <app-mcl-button text="Post GL" primary="true" (click)="postGLClicked()">
    </app-mcl-button>
  </div>
  &nbsp;
  <kendo-grid
    [kendoGridBinding]="gridDataExceptionsNoDupes"
    [sortable]="true"
    [scrollable]="true"
    [height]="350"
    style="height: 30vh">
    <kendo-grid-column field="invoiceNumber" title="Invoice #" filterable="true" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="storeId" title="Store #" filterable="true" [width]="150"></kendo-grid-column>
  </kendo-grid>


  <div fxLayout="row" fxLayoutAlign="end stretch" style="margin-top: 10px">
    <app-mcl-button text="Export" primary="true" (click)="exportClicked()">
    </app-mcl-button>
    &nbsp;
    &nbsp;
    <app-mcl-button text="Back" primary="true" (click)="backClicked()">
    </app-mcl-button>
  </div>

</div>

<div kendoDialogContainer></div>
